/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './person-name.reducer';

export const PersonNameDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const personNameEntity = useAppSelector(state => state.personName.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="personNameDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.personName.detail.title">PersonName</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.personName.id">Id</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.id}</dd>
          <dt>
            <span id="preferred">
              <Translate contentKey="tinyMedicRestApp.personName.preferred">Preferred</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.preferred ? 'true' : 'false'}</dd>
          <dt>
            <span id="givenName">
              <Translate contentKey="tinyMedicRestApp.personName.givenName">Given Name</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.givenName}</dd>
          <dt>
            <span id="prefix">
              <Translate contentKey="tinyMedicRestApp.personName.prefix">Prefix</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.prefix}</dd>
          <dt>
            <span id="middleName">
              <Translate contentKey="tinyMedicRestApp.personName.middleName">Middle Name</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.middleName}</dd>
          <dt>
            <span id="familyNamePrefix">
              <Translate contentKey="tinyMedicRestApp.personName.familyNamePrefix">Family Name Prefix</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.familyNamePrefix}</dd>
          <dt>
            <span id="familyName">
              <Translate contentKey="tinyMedicRestApp.personName.familyName">Family Name</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.familyName}</dd>
          <dt>
            <span id="familyNameSufix">
              <Translate contentKey="tinyMedicRestApp.personName.familyNameSufix">Family Name Sufix</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.familyNameSufix}</dd>
          <dt>
            <span id="familyName2">
              <Translate contentKey="tinyMedicRestApp.personName.familyName2">Family Name 2</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.familyName2}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.personName.active">Active</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.personName.created">Created</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.created ? <TextFormat value={personNameEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.personName.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.personName.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.timestampentry}</dd>
          <dt>
            <span id="totalReading">
              <Translate contentKey="tinyMedicRestApp.personName.totalReading">Total Reading</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.totalReading}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.personName.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.personName.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{personNameEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.personName.patient">Patient</Translate>
          </dt>
          <dd>{personNameEntity.patient ? personNameEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.personName.doctor">Doctor</Translate>
          </dt>
          <dd>{personNameEntity.doctor ? personNameEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.personName.pharmacist">Pharmacist</Translate>
          </dt>
          <dd>{personNameEntity.pharmacist ? personNameEntity.pharmacist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.personName.diaglabAssistant">Diaglab Assistant</Translate>
          </dt>
          <dd>{personNameEntity.diaglabAssistant ? personNameEntity.diaglabAssistant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.personName.hospitalAssistant">Hospital Assistant</Translate>
          </dt>
          <dd>{personNameEntity.hospitalAssistant ? personNameEntity.hospitalAssistant.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/person-name" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/person-name/${personNameEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PersonNameDetail;
